import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import CellcomEnergyBlockData from '../../../Models/Content/CellcomEnergyBlockData';
import CellcomEnergy from './cellcomEnergy';

export default class CellcomEnergyBlock extends EpiComponent<CellcomEnergyBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = [];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(' ')}>
        <CellcomEnergy iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
